import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button,  Row, Col, Select, message } from 'antd';
import { useProjectNextCode } from 'hooks';
import { DatePicker } from 'components/atoms'
import { fetcher } from 'services';
import { MSG } from 'commons/constants';
import { dateFormat } from 'utils/date-utils';

export interface ProjectDiagnoseCopyModalProps extends PopupProps {
    info: ProjectDiagnoseInfoDto;    
}

const ProjectDiagnoseCopyModal = ({ 
    isOpen,   
    onClose,         
    info}: ProjectDiagnoseCopyModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isFormDone, setIsFormDone] = useState<boolean>(false);

  /* ======================================================
  * hooks
  * ====================================================== */  
   const { codeList } = useProjectNextCode({ id: info.group_srl })

   /* ======================================================
   * variables
   * ====================================================== */
   const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };

    const onSubmit = (e) => {
        if (info.id > 0) {
            fetcher.project.postProjectDiagnoseCopy ({
                id: info.id,
                project_group_srl: e.next_group_srl, 
                project_date: e.project_date ? dateFormat(e.project_date, 'YYYY-MM-DD'):null,
            })
            .then((res) => {
                switch (res.code) {
                    case 200:
                        message.info(MSG.SUCCESS_COPY, 1);
                        onClose?.(true);
                    break;
                    default:  
                    break;
                };
            }); 
        }
    };

    const onChangeForm = () => { 
        setIsFormDone(true);
    };      

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    if (!!codeList) {
        form.setFieldsValue({
            next_group_srl: info.group_srl,               
        });
    }
}, [codeList])

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={750} title={'프로젝트 진단 일정 복사'} closable>
            <Form
                form={form}
                name="ProjectInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Row>
                    <Col span={12}>
                    <Form.Item label={'기존 프로젝트명'}>
                        <label>{info.group_name}</label>                  
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item label={'기존 진단 일정'}>
                        <label>{info.diagnose_start_date}~{info.diagnose_end_date}</label>                  
                    </Form.Item>   
                    </Col>            
                </Row>
                <Form.Item name="next_group_srl" label={'복사 프로젝트명'} rules={[{ required: true, message: '' }]}>
                    <Select 
                        placeholder="복사 프로젝트 선택" 
                        options={codeList} />                       
                </Form.Item> 
                <Form.Item 
                    name="project_date" 
                    label={'복사 진단 시작일'}
                    rules={[{ required: true, message: '' }]}
                >
                    <DatePicker showTime={false} format="YYYY-MM-DD" />                    
                </Form.Item>                                 
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel} style={{marginRight: "5px"}}>취소</Button>
                    <Button htmlType="submit"  type="primary" disabled={!isFormDone}>복사</Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(ProjectDiagnoseCopyModal);    